import React, { useState, useEffect } from 'react';

import Warning from 'jsx/elements/messages/Warning';
import apiRequest from 'utils/api/apiRequest';
import { useLocale } from './../../components/special/LanguageProvider';

import TextChangesModal from './TextChangesModal';
import './styles.less';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export default () => {
  const [editingForm, setEditingForm] = useState(null);
  const { t } = useLocale();
  const [data, setData] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    apiRequest(BASE_URL + '/admin/form/formactiongroups/').then(d => {
      setData(d.filter(item => item.forms.length > 0));
    });
  }, []);

  function openModal(form) {
    setShowSuccess(false);
    setEditingForm(form);
    setShowModal(true);
  }

  return (
    <div>
      <h1>{t('Bréfa umsýsla')}</h1>
      {showSuccess && (
        <Warning
          messageType="success"
          messageHeader={t('admin_textchanges_updateSuccess', editingForm.name)}
        />
      )}
      {data.map((item, index) => (
        <div className="text-changes-list-item" key={index}>
          <div>
            <span className="tag tag-color-gray-dark" style={{ marginRight: 20 }}>
              {item.actionName}
            </span>
            <span>
              <div style={{ wordWrap: 'break-word' }}>
                {item.forms.map((form, index) => {
                  const isLast = index === item.forms.length - 1;
                  return (
                    <span key={form.formID} className="text-14">
                      <span onClick={() => openModal(form)} className="text-blue cursor-pointer">
                        {form.name}
                      </span>
                      {!isLast && <span style={{ margin: '0 10px' }}>|</span>}
                    </span>
                  );
                })} 
              </div>
            </span>
          </div>
        </div>
      ))}

      {showModal && (
        <TextChangesModal
          form={editingForm}
          onClose={() => setShowModal(false)}
          onSuccess={() => setShowSuccess(true)}
        />
      )}
    </div>
  );
};
